import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.partyId_1 = partyId;
        this.pairingSetId_1 = pairingSetId;
        this.date_1 = date;
        this.pairs_1 = pairs;
        this.discordMessageId_1 = discordMessageId;
        this.slackMessageId_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.partyId_1.toString() + ', pairingSetId=' + this.pairingSetId_1.toString() + ', date=' + this.date_1.toString() + ', pairs=' + toString(this.pairs_1) + ', discordMessageId=' + toString(this.discordMessageId_1) + ', slackMessageId=' + toString(this.slackMessageId_1) + ')';
      }
      hashCode() {
        var result = this.partyId_1.hashCode();
        result = imul(result, 31) + this.pairingSetId_1.hashCode() | 0;
        result = imul(result, 31) + this.date_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.pairs_1) | 0;
        result = imul(result, 31) + hashCode(this.discordMessageId_1) | 0;
        result = imul(result, 31) + hashCode(this.slackMessageId_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.partyId_1.equals(other.partyId_1))
          return false;
        if (!this.pairingSetId_1.equals(other.pairingSetId_1))
          return false;
        if (!this.date_1.equals(other.date_1))
          return false;
        if (!equals(this.pairs_1, other.pairs_1))
          return false;
        if (!equals(this.discordMessageId_1, other.discordMessageId_1))
          return false;
        if (!equals(this.slackMessageId_1, other.slackMessageId_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
